module.exports = __webpack_public_path__ + "img/empty-temp-introduce-4.fd94cfb8.jpg";